import React, { forwardRef, LegacyRef } from 'react'
import styles from './SectionContainer.module.scss'
import cl from 'classnames'
import { SectionContainerProps } from './SectionContainer.types'

const SectionContainerComponent = (props: SectionContainerProps, ref: LegacyRef<HTMLDivElement>) => {
  const {
    children,
    className,
    extraPaddingBottom,
    preset,
    ...rest
  } = props

  return (
    <div
      ref={ref}
      className={cl(styles.container, styles[preset], {
        [styles.extraPaddingBottom]: extraPaddingBottom
      }, className)}
      {...rest}
    >
      {children}
    </div>
  )
}

const SectionContainer = forwardRef(SectionContainerComponent)
export { SectionContainer }
